/**
 * SIMODE API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AreaPublic { 
    Name: string;
    HeatmapInterval?: number;
    Id: string;
    BackgroundImage: string | null;
    Width: number | null;
    Height: number | null;
    CellsX: number | null;
    CellsY: number | null;
    Index: number;
    CreationDate: string;
    LastEdit: string | null;
    LastEditBy: string | null;
    BuildingId: string;
    GatewayMacAddress: string | null;
    ZoneCount: number;
    SensorCount: number;
}

